import { takeLatest } from 'redux-saga/effects';

import {
    APPLY_CHANGE_REQUEST,
    PUBLISH_CHANGE_REQUEST,
    CANCEL_MY_CHANGE_REQUEST,
    REVIEW_CHANGE_REQUEST
} from '../redux.actionTypes';
import applyChangeRequestWorker from './applyChangeRequestWorker';
import publishChangeRequestWorker from './publishChangeRequestWorker';
import cancelMyChangeRequestWorker from './cancelMyChangeRequestWorker';
import reviewChangeRequestWorker from './reviewChangeRequestWorker';

export default function* () {
    yield takeLatest(APPLY_CHANGE_REQUEST, applyChangeRequestWorker);
    yield takeLatest(PUBLISH_CHANGE_REQUEST, publishChangeRequestWorker);
    yield takeLatest(CANCEL_MY_CHANGE_REQUEST, cancelMyChangeRequestWorker);
    yield takeLatest(REVIEW_CHANGE_REQUEST, reviewChangeRequestWorker);
}
